import { Component, OnInit, DoCheck } from '@angular/core';
import {environment} from '@environments/environment';

@Component({
  selector: 'bid-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, DoCheck {
  //showHistoricalSearch: boolean;
  urlKpiDashboard : string = environment.dashboard.kpi;

  constructor() {
    //this.showHistoricalSearch = false;
  }

  ngOnInit() {
    //this.showHistoricalSearchService.setShowHistoricalSearch(false);
    console.log('dashboard', this.urlKpiDashboard)
    
    const iframe = document.getElementById('dashboardIframe') as HTMLIFrameElement;
    iframe.src = this.urlKpiDashboard;
  }

  ngDoCheck() {
    
  }
}
